export default "__VITE_ASSET__BioUeEm___"